<template>
	<button class="type-button" :class="_class" :style="_style" @click="$emit('click', $event)">
		<slot>
			行动按钮
		</slot>
	</button>
</template>

<script>
	export default {
		name: 'type-button',
		props: {
			size: {
				type: String,
				// default: '19px'
				default: '16px'
			},
			weight: {
				type: String,
				default: '300'
			},
			height: {
				type: String,
				// default: '50px'
				default: '40px'
			},
			padding: {
				type: String,
				// default: '0 20px'
				default: '0 18px'
			},
			round: {
				type: Boolean,
				default: false
			},
			border: {
				type: Boolean,
				default: false
			},
			whitebackdrop: {
				type: Boolean,
				default: false
			}
		},
		computed: {
			_class() {
				if (this.border) {
					return this.whitebackdrop ? 'border-white-backdrop' : 'border-other-backdrop';
				}
				return this.whitebackdrop ? 'white-backdrop' : 'other-backdrop';
			},
			_style() {
				let style = `font-size: ${this.size};font-weight: ${this.weight};`;
				if (this.round) {
					style += `border-radius: 50vw;`;
				}
				if (this.border === false) {
					style += `height: ${this.height};padding: ${this.padding};`;
				}
				return style;
			}
		}
	}
</script>

<style scoped lang="less">
	.type-button{
		border: none;
		outline: none;
		cursor: pointer;
		overflow: hidden;
		position: relative;
		background-color: transparent;
		font-family: 'Montserrat', sans-serif;
		transition: all 500ms ease-in-out;
		&::after{
			content: '';
			display: block;
			position: absolute;
			height: 100vw;
			width: 100vw;
			top: 50%;
			left: 50%;
			border: none;
			outline: none;
			border-radius: 50%;
			pointer-events: none;
			background-repeat: no-repeat;
			background-position: 50%;
			opacity: 0;
			transition: transform 1.8s ease, opacity 2.2s linear;
			transform: translate(-50%, -50%) scale(2);
		}
		&:active{
			&::after{
				opacity: .5;
				transition: 0s;
				transform: translate(-50%, -50%) scale(0);
			}
		}
	}
	.white-backdrop{
		color: #000000;
		&::after{
			background-image: radial-gradient(circle, rgba(153, 153, 153, 0.5) 50%, transparent 50%);
		}
	}
	.other-backdrop{
		color: #FFFFFF;
		&::after{
			background-image: radial-gradient(circle, rgba(255, 255, 255, 0.5) 50%, transparent 50%);
		}
	}
	.border-white-backdrop, .border-other-backdrop{
		width: 100%;
		padding: 0;
		height: 46px;
		border-width: 2px;
		border-style: solid;
	}
	.border-white-backdrop{
		color: #000000;
		border-color: #888888;
		&:hover{
			color: #FFFFFF;
			background-color: #888888;
		}
		&::after{
			background-image: radial-gradient(circle, rgba(255, 255, 255, 0.5) 50%, transparent 50%);
		}
	}
	.border-other-backdrop{
		color: #FFFFFF;
		border-color: #FFFFFF;
		&:hover{
			color: #000000;
			background-color: #FFFFFF;
		}
		&::after{
			background-image: radial-gradient(circle, rgba(153, 153, 153, 0.5) 50%, transparent 50%);
		}
	}
</style>
